import { IonContent, IonPage } from '@ionic/react';
import Accueil from '../components/figma/Accueil';
import MobilePreview from '../components/MobilePreview';
import ScaledFigmaCanvas from '../components/figma/ScaledFigmaCanvas';
import { FIGMA_BASE_HEIGHT, FIGMA_BASE_WIDTH } from '../components/figma/figma.constants';
import './Home.css';

const Home: React.FC = () => {
  return (
    <IonPage>
      <IonContent fullscreen className="home-content">
        <MobilePreview ariaLabel="Prévisualisation mobile">
          <ScaledFigmaCanvas
            baseWidth={FIGMA_BASE_WIDTH}
            baseHeight={FIGMA_BASE_HEIGHT}
            ariaLabel="Accueil mobile"
          >
            <Accueil />
          </ScaledFigmaCanvas>
        </MobilePreview>
      </IonContent>
    </IonPage>
  );
};

export default Home;
